import { memo, useCallback } from 'react';
import { useDispatch, useSelector } from '@bonanza-social/toolkit/state';
import { PressableIcon } from '@bonanza-social/moonlight';
import {
  verifyBiometrics,
  selectBiometricsType,
  selectBiometricsEnabled,
} from '../../state/biometrics/biometrics.slice';

function BiometricsButton() {
  const dispatch = useDispatch();
  const biometryType = useSelector(selectBiometricsType);
  const biometricsEnabled = useSelector(selectBiometricsEnabled);

  const onPress = useCallback(() => {
    dispatch(verifyBiometrics());
  }, [dispatch]);

  if (!biometryType || !biometricsEnabled) {
    return;
  }

  return (
    <PressableIcon
      name={
        biometryType === 'Biometrics' || biometryType === 'TouchID'
          ? 'touchId'
          : 'faceId'
      }
      iconWidth="space-600"
      iconHeight="space-600"
      backgroundColor="inputBackground"
      borderWidth="border-width-025"
      borderColor="borderSecondary"
      color="darkSurfaceTertiary"
      borderRadius="radius-200"
      padding="space-400"
      onPress={onPress}
    />
  );
}

export default memo(BiometricsButton);
